import styles from "./TopMoversCard.module.css"
import { AiOutlineArrowDown, AiOutlineArrowUp} from "react-icons/ai"

const TopMoversCard = (props) => {
  const { image, symbol } = props
  
  function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }
  

  const PRICE = getRandomArbitrary(0, 20)

  const PRICE_CHANGE = (Math.random() * (-5.00 - 1.00 + 1.00) + 1.00).toFixed(2)
  const priceChangeStyle = PRICE_CHANGE <= 0 ? styles.color_red : styles.color_green
  const priceChangeArrow = PRICE_CHANGE <= 0 ? <AiOutlineArrowDown color="red" size={15} /> :
  <AiOutlineArrowUp color="green" size={15} />
  return (
    <div className={styles.top_movers_card_container}>
    <div className={styles.top_movers_card_content}>
        <img src={image} alt=""/>
  <div className={styles.top_movers_card_info}>
          <div className={styles.top_movers_symbol}>{ symbol}</div>
                  <div className={styles.top_movers_amount}>
            <div>${ PRICE.toFixed(2)}</div>
            <div className={`${styles.performance} ${priceChangeStyle}`}>{priceChangeArrow} { PRICE_CHANGE}%</div>
                  </div>
        </div>
    </div>
</div>
  )
}

export default TopMoversCard